export default function (value, digits = 2) {
  if (!value) return ''
  const FORMATTER = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: digits
  })
  return FORMATTER.format(Number(value))
}
